import { useCrmUrl } from '@/utils/crm-url';

type TempEmbryoLinkProps = {
  embryoId: string;
  embryoName: string;
};

export const TempEmbryoLink = ({
  embryoId,
  embryoName,
}: TempEmbryoLinkProps) => {
  const crmUrl = useCrmUrl();

  const url = new URL('main.aspx', crmUrl);
  url.searchParams.set('etc', '10098');
  url.searchParams.set(
    'extraqs',
    'formid=f6afa57a-804d-4ca0-a936-75df1f9d82fb',
  );
  url.searchParams.set('id', `{${embryoId}}`);
  url.searchParams.set('pagetype', 'entityrecord');
  url.hash = '811837321';

  return (
    <a href={url.toString()} target="_blank" rel="noopener noreferrer">
      {embryoName}
    </a>
  );
};
